import { styleHelpers } from '@nocowanie/core';

export const globalNocowanieStyles = {
    img: { filter: 'contrast(1.05) saturate(1.15)' },
    '.gm-style img': { filter: 'none' },
};

export const globalNocowanieStylesRaw = styleHelpers.convertToRawCss(globalNocowanieStyles);
